import { Link as RouterLink } from 'react-router-dom';
import { Box, BoxProps } from '@mui/material';

// ----------------------------------------------------------------------

interface Props extends BoxProps {
  disabledLink?: boolean;
}

// ElectionSetu mark (no wordmark); the full logo is /logo/logo_full.png
export default function Logo({ disabledLink = false, sx }: Props) {
  const logo = (
    <Box
      component="img"
      src="/logo/logo_single.png"
      alt="ElectionSetu"
      sx={{
        width: 40,
        height: 40,
        // The mark is wider than tall: fit it whole instead of cropping
        objectFit: 'contain',
        ...sx,
      }}
    />
  );

  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="/">{logo}</RouterLink>;
}
